import { useState } from "react";
import Table from "../../ui/Table/Table";
import { tableIndex } from "../../utils/table.utils";
import Loading from "../../components/Loading";
import { CrossIcon, DoneIcon } from "../../utils/icon.utils";
import { GroupBtn } from "../../ui/GroupBtn";
import {
  useAssignRolePermissionMutation,
  useGetAllRolePermissionsQuery
} from "../../utils/role.utils";
import { useParams } from "react-router-dom";
import { textStarCase } from "../../utils/string.utils";
import PageLayout from "../../layouts/PageLayout";
import { arrayMap } from "../../utils/array.utils";

export default function RolePermissionPage() {
  const pageSize = 10;
  const [currentPage, setCurrentPage] = useState(1);
  const { slug } = useParams();

  const { loading: assignLoading, assignRolePermission } = useAssignRolePermissionMutation([
    "assignRolePermission"
  ]);

  const { loading, data } = useGetAllRolePermissionsQuery({
    query: `?page=${currentPage}&size=${pageSize}`,
    slug
  });

  const totalPage = data?.last_page === 1 && data?.total === 0 ? 0 : data?.last_page;

  const breadCrumbs = [
    {
      name: "Settings",
      link: "/settings"
    },
    {
      name: "Role",
      link: "/settings/role"
    },
    {
      name: textStarCase(slug)
    }
  ];

  const thead = ["#", "Module", "Permissions"];

  const Permissions = ({ data: permissionItems }) => {
    const newPermissions = [...(permissionItems ?? [])];
    const newPermissionsLength = newPermissions.length;
    if (newPermissionsLength === 0) {
      return "No permissions";
    }
    const btns =
      arrayMap(newPermissions, (permissionItem, index) => {
        const permissionId = permissionItem?.pivot?.id;
        const isTag = permissionItem?.assigned;
        const icon = isTag ? DoneIcon : CrossIcon;
        const color = isTag ? "success" : "danger";
        const name = permissionItem?.name ?? index + 1;

        const handleAssignRolePermission = async () => {
          const permissions = [permissionId];

          await assignRolePermission({
            role_slug: slug,
            permissions
          });
        };

        return {
          name: name,
          color: color,
          icon: icon,
          onClick: () => handleAssignRolePermission()
        };
      }) || [];

    return <GroupBtn justify="start" btns={btns} loading={assignLoading} />;
  };

  const tbody =
    arrayMap(data?.data, (item, index) => ({
      "#": tableIndex(index, currentPage, pageSize),
      Module: item?.name ?? "",
      Permissions: <Permissions data={item?.app_permissions ?? []} />,
      ...item
    })) || [];

  const isLoading = loading;

  return (
    <PageLayout
      title="Role Manager"
      subTitle={`Total: ${data?.total ?? 0}`}
      breadCrumbs={breadCrumbs}>
      {loading ? "Loading..." : ""}

      <Table
        thead={thead}
        tbody={tbody}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        totalPage={totalPage}
      />
      {<Loading loading={isLoading} />}
    </PageLayout>
  );
}
